import Slider from "./components/slider";
import $ from "jquery";
import BlogVue from "./vue/blog.vue";
class App {
    constructor() {

        function modalCookies(){
            // Check if the modal should be displayed
            const showModal = localStorage.getItem('showModal');

            if (!showModal) {
                // Show the modal if it hasn't been closed before
                document.getElementById('modalCookies').style.display = 'block';
            }

            // Close the modal and prevent it from reopening
            document.getElementById('modalCookiesClose').addEventListener('click', function() {
                document.getElementById('modalCookies').style.display = 'none';
                localStorage.setItem('showModal', 'false');
            });
        }


        const buttons = document.querySelectorAll('.button-primary, .button-secondary');
        const menus = document.querySelectorAll('header .menu li a');

        const title = document.querySelectorAll('h1 strong, h2 strong, h3 strong, h4 strong, h5 strong');
        title.forEach((z) => {
            z.innerHTML = "<span>" + z.innerHTML + "</span>";
        })

        buttons.forEach((z) => {
            z.innerHTML = "<span>" + z.innerHTML + "</span>";
        })


        menus.forEach((z) => {
            z.innerHTML = "<span>" + z.innerHTML + "</span>";
        })

        // Wait for the page to finish loading
        window.addEventListener('load', () => {
            Slider();
            modalCookies();
            // Get the button element
            const backToTopBtn = document.getElementById('backToTopBtn');

            // Scroll to top when the button is clicked
            backToTopBtn.addEventListener('click', () => {
                window.scrollTo({
                    top: 0,
                    behavior: 'smooth'
                });
            });


            $('.extras li a').click(function () {
                $('.extras li').removeClass("act");
                $(this).parent().addClass("act");
                $("#textExtra").html($('.text', $(this).parent()).html());
                return false;
            });


            $(".single-produto .uslides li").click(function () {
                console.log($("img", this).attr("src"));
                $(".thumbnail img").attr("src", $("img", this).attr("src")).attr('srcset',  $("img", this).attr("srcset"));
            });

            var app = document.querySelector("#blog");
            if(app) new BlogVue();


            $("#tarefa_primaria").change(function () {
               $("#filtro").attr("action", $(this).val())
            });

            if($("#tarefa_primaria").length > 0 ) {
                const url = new URL(window.location.href);
                const urlWithoutQueryString = url.origin + url.pathname;
                $("#tarefa_primaria").val(urlWithoutQueryString);
            }

            if($("#recomendacao").length > 0 ) {
                const queryString = window.location.search;
                const urlParams = new URLSearchParams(queryString);
                const recomendacao = urlParams.get('recomendacao');
                if(recomendacao)
                $("#recomendacao").val(recomendacao);
            }

            $(".button-mobile").click(function () {
                $(".menu-menu-principal-container").slideToggle();
            });

            window.addEventListener('scroll', function() {
                // Verificar a posição do scroll
                var scrollTop = window.pageYOffset || document.documentElement.scrollTop;

                // Adicionar ou remover a classe dependendo da posição do scroll
                if (scrollTop === 0) {
                    document.body.classList.add('top-scroll');
                } else {
                    document.body.classList.remove('top-scroll');
                }
            });


            $("a.search").click(function() {
                $('input[type=search]').toggleClass("act");
            })


            $("<span></span>").appendTo(".menu-item-has-children");

            $(".menu-item-has-children > span").click(function () {
                $('> .sub-menu', $(this).parent()).slideToggle();
            });

            $(".contato.pag-contato .choice").click(function () {
                $(".contato-choice").hide();
               $(".contato.pag-contato .choice").removeClass("act");
               $(this).addClass("act");
                $(".contato-choice" + "#" + $(this).attr("data-id")).show();
            });

            $(".whatsapp-icon").click(function () {
                $('.popup').fadeToggle();
                return false;
            })

        });


        function getAltura(){
            // Get slider values
            var parent = this.parentNode;
            var slides = parent.getElementsByTagName("input");
            var slide1 = parseFloat( slides[0].value );
            var slide2 = parseFloat( slides[1].value );
            // Neither slider will clip the other, so make sure we determine which is larger
            if( slide1 > slide2 ){ var tmp = slide2; slide2 = slide1; slide1 = tmp; }

            var displayElement = parent.getElementsByClassName("rangeValuesAltura")[0];
            displayElement.innerHTML = slide1 + "m - " + slide2 + "m";
        }

        function getPeso(){
            // Get slider values
            var parent = this.parentNode;
            var slides = parent.getElementsByTagName("input");
            var slide3 = parseFloat( slides[0].value );
            var slide4 = parseFloat( slides[1].value );
            // Neither slider will clip the other, so make sure we determine which is larger
            if( slide3 > slide4 ){ var tmp = slide4; slide4 = slide3; slide3 = tmp; }

            var displayElement2 = parent.getElementsByClassName("rangeValuesPeso")[0];
            if(slides[0].value == 1.0) displayElement2.innerHTML = slide3 + " tonelada - " + slide4 + " toneladas";
            else displayElement2.innerHTML = slide3 + " toneladas - " + slide4 + " toneladas";
        }

        window.onload = function(){



            // Initialize Sliders
            var sliderSections = document.getElementsByClassName("range-slider-altura");
            for( var x = 0; x < sliderSections.length; x++ ){
                var sliders = sliderSections[x].getElementsByTagName("input");
                for( var y = 0; y < sliders.length; y++ ){
                    if( sliders[y].type ==="range" ){
                        sliders[y].oninput = getAltura;
                        // Manually trigger event first time to display values
                        sliders[y].oninput();
                    }
                }
            }
            var sliderSections2 = document.getElementsByClassName("range-slider-peso");
            for( var x = 0; x < sliderSections2.length; x++ ){
                var sliders = sliderSections2[x].getElementsByTagName("input");
                for( var y = 0; y < sliders.length; y++ ){
                    if( sliders[y].type ==="range" ){
                        sliders[y].oninput = getPeso;
                        // Manually trigger event first time to display values
                        sliders[y].oninput();
                    }
                }
            }
        }
    }
}

new App();